import { CommonHelperFunctions } from "@kuika/kuika-cl-model";
import * as React from "react";
import { UserService } from "../../services/user-service";
import { IWithHistoryProp, withHistory } from "../../shared/hoc/with-history";
import { KMainFunctions } from "../../shared/utility/main-functions";
import AuthCheckYourInboxSvg from "../../svgs/auth-check-your-inbox.svg";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import KuikaH4 from "../ui-kit/typography/H4/H4";
import KuikaText from "../ui-kit/typography/Text/Text";
import { AuthLogo } from "./auth-logo";

export interface IEmailConfirmationState {}

export interface IEmailConfirmationProps {}

class EmailConfirmation extends React.PureComponent<
  IEmailConfirmationProps & IWithHistoryProp,
  IEmailConfirmationState
> {
  constructor(props: IEmailConfirmationProps & IWithHistoryProp) {
    super(props);

    if (!CommonHelperFunctions.isRedirectedBy("signup")) {
      this.props.navigator.gotoRoot();
    }

    this.state = {};
  }

  goToSignIn = () => {
    UserService.Logout(undefined, true);
  };

  render() {
    const isMainAI = KMainFunctions.isMainAI();

    return (
      <div className="email-confirmation">
        <div className="email-confirmation__content">
          <div className="email-confirmation__top-section">
            <AuthLogo />

            <div className="email-confirmation__check-inbox-card">
              <div className="email-confirmation__title-row">
                <AuthCheckYourInboxSvg />
                <KuikaH4>Check your inbox</KuikaH4>
              </div>

              <KuikaText className="email-confirmation__message-text">
                {isMainAI
                  ? "We have sent you an e-mail to activate your account. After the activation process, you are ready to start."
                  : "We have sent you an e-mail to activate your account. After the activation process, you are ready to use Kuika."}
              </KuikaText>

              <div className="email-confirmation__return-btn">
                <KuikaButton
                  type="tertiary"
                  size="lg"
                  uppercase={true}
                  onClick={this.goToSignIn}
                  style={{ width: "100%" }}
                >
                  Return to sign in
                </KuikaButton>
              </div>
            </div>
          </div>

          {!isMainAI && (
            <div className="email-confirmation__bottom-section">
              <KuikaButton
                type="text"
                size="sm"
                onClick={() => window.open("https://www.kuika.com/en/legal/privacy", "_blank")}
                uppercase
              >
                Privacy
              </KuikaButton>
              <KuikaButton
                type="text"
                size="sm"
                onClick={() => window.open("https://www.kuika.com/en/legal/terms", "_blank")}
                uppercase
              >
                Terms
              </KuikaButton>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const emailConfirmation = withHistory<IEmailConfirmationProps>(EmailConfirmation);
export { emailConfirmation as EmailConfirmation };
